import styled from '@emotion/styled';
import { APP_NAME } from '@myme/utils';
import { feedPageRoute } from 'src/routes/route-list';
import { Link, Typography } from 'src/components/atoms';

const Logo = styled.img`
  height: 3rem;
  width: 3rem;
  margin-bottom: 0.5rem;
  margin-right: 1rem;
`;

const LogoContainer = styled.div`
  position: relative;
  z-index: 5;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
`;

export const AuthLogo = () => {
  return (
    <Link to={feedPageRoute} underline='none'>
      <LogoContainer>
        <Logo src='/LogoIcon.png' />
        <Typography variant='h4'>{APP_NAME}</Typography>
      </LogoContainer>
    </Link>
  );
};
